import React, { useEffect, useMemo, useState } from 'react'
import SpinWheelService from '../../Services/SpinWheelService';
import { useNavigate } from 'react-router-dom';
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { showErrorToast } from '../../Constant/Notification';
const SpinWheelForm = ({spDetail}) => {
const [bannerUrl, setBannerUrl]=useState("");
const [wheelTitle, setWheelTitle] = useState("");
const [winInstruction, setWinInstruction] = useState("");
const [loseInstruction, setLoseInstruction] = useState("");
const [priceExpiryDays, setPriceExpiryDays] = useState("")

const [selectedBannerImage, setSelectedBannerImage] = useState()
const userObj = JSON.parse(localStorage.getItem("userData"));
const userUid = userObj?.user?.uid;
const userRole = userObj?.user?.role;


const spObj ={
wheelTitle: wheelTitle,
giftExpiryDays: parseInt(priceExpiryDays),
bannerUrl: bannerUrl,
winInstruction: winInstruction,
loseInstruction: loseInstruction,
createdBy: userUid,
modifiedBy: userUid
}
const navigate = useNavigate()

useEffect(() => {
  if (
    wheelTitle &&
    winInstruction &&
    loseInstruction &&
    priceExpiryDays &&
    bannerUrl
  ) {
    spDetail(spObj)
  }
}, [wheelTitle, winInstruction, loseInstruction, priceExpiryDays, bannerUrl]);
console.log(spObj)

//   const handleBannerUpload =async(e)=>{
//     const file = e.target.files[0];
//     setSelectedBannerImage(file ? file.name : null)

//     try {

//       const formData = new FormData();
//       formData.append("file", file);
// const bannerFolder = "spinWheelBannerImages"
//       const response = await SpinWheelService.createBannerImageTemplate(formData, bannerFolder)
//       setBannerUrl(response.data.imageUrl);
//     } catch (error) {
//       console.error("Error uploading file:", error);
//       // showErrorToast("Failed to upload file. Please try again.");
//     }
//   }


const handleBannerUpload = async (e) => {
  const file = e.target.files[0];
  if (!file) {
    setSelectedBannerImage(null);
    return;
  }


  try {
    // Validate aspect ratio
    const validateAspectRatio = (file) =>
      new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          const img = new Image();
          img.onload = () => {
            const aspectRatio = img.width / img.height;
            // Check if aspect ratio is approximately 3.5:1
            if (Math.abs(aspectRatio - 3.5) > 0.1) {
              reject(new Error("Please upload an image with a 3.5:1 aspect ratio."));
            } else {
              resolve();
            }
          };
          img.src = event.target.result;
        };
        reader.onerror = () => reject(new Error("Failed to read the file."));
        reader.readAsDataURL(file);
      });

    await validateAspectRatio(file);

    // Set selected banner image name
    setSelectedBannerImage(file.name);

    // Create FormData and upload
    const formData = new FormData();
    formData.append("file", file);
    const bannerFolder = "spinWheelBannerImages";
    const response = await SpinWheelService.createBannerImageTemplate(formData, bannerFolder);

    // Set the uploaded image URL
    setBannerUrl(response.data.imageUrl);
  } catch (error) {
    console.error("Error uploading file:", error);
    // Show toast for specific errors
    if (error.message === "Please upload an image with a 3.5:1 aspect ratio.") {
      showErrorToast(error.message); // Replace with your error toast function
    } else {
      showErrorToast("Failed to upload file. Please try again."); // Replace with your error toast function
    }
  }
};

console.log(bannerUrl)

const handleExpiryDays =(e)=>{
  const newDays = e.target.value.replace(/\D/g, "");
  setPriceExpiryDays(newDays)
}

const toolbarOptions = useMemo(
  () => [
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link" ],
    [{ color: [] }, { background: [] }],
      [{ align: [] }],
    ["clean"],
  ],
  []
);

const module = useMemo(
  () => ({
    toolbar: {
      container: toolbarOptions,

    },
  }),
  [toolbarOptions]
);
  return (
    <div className='p-3'>
      <div className='flex-col flex gap-5'>
        <div>

        <h1 className='text-xl font-medium'>Wheel title</h1>
        <input type="text" placeholder='Type here' onChange={(e)=>(setWheelTitle(e.target.value))}className=' w-full h-12 px-3 border border-gray-300 bg-appGrayBackground rounded-lg focus:outline-none' />
        </div>
<div>

<h1 className='text-xl font-medium'>Banner</h1>
<input
                  id={`fileInput`}
                  type="file"
                  className="hidden"
            accept=".jpeg, .jpg, .png, .webp, .svg"

                  onChange={handleBannerUpload}

                  />
                <label
                  htmlFor={`fileInput`}
                  className="w-full h-20 flex items-center justify-center border border-gray-300 bg-appGrayBackground rounded-lg cursor-pointer"
                  >


{bannerUrl ? (
              <img
                src={bannerUrl}
                alt="Preview"
                className="w-full h-full object-cover "
              ></img>
            ) : (
              <span className="text-gray-800 text-sm">
                + Add Banner Image (3.5:1)
              </span>
            )}
                </label>

                    </div>

                    <div>



                <h1 className='text-xl font-medium'>Win Instruction</h1>
<ReactQuill
  onChange={setWinInstruction}
  modules={module}
  className="w-full h-auto "
  placeholder='Type here ...'
/>
{/* <textarea
  className="w-full h-32 border border-gray-300 rounded-lg p-2 focus:outline-none"
  placeholder="Type here..."
></textarea> */}
  </div>

<div>

<h1 className='text-xl font-medium'>Lose Instruction</h1>
{/* <textarea
  className="w-full h-32 border border-gray-300 rounded-lg p-2 focus:outline-none"
  placeholder="Type here..."
  onChange={(e)=>{setLoseInstruction(e.target.value)}}

></textarea> */}

<ReactQuill
  onChange={setLoseInstruction}
  modules={module}
  className="w-full h-auto "
  placeholder='Type here ...'
/>
  </div>
  <div>

        <h1 className='text-xl font-medium'>Win Price expiry Days</h1>
        <input type="text" placeholder='Type here' value={priceExpiryDays} onChange={handleExpiryDays}className=' w-full h-12 px-3 border border-gray-300 bg-appGrayBackground rounded-lg focus:outline-none' />
        </div>

      </div>
    </div>
  )
}

export default SpinWheelForm
